import * as React from 'react';
import { SVGProps } from 'react';

const SvgMoney = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M36.666 12.833h-32v15.5h32v-15.5Z"
    />
    <path
      fill="currentColor"
      d="M20.667 15.333c-2.834 0-5.334 2.334-5.334 5.334 0 3 2.334 5.333 5.334 5.333C23.5 26 26 23.667 26 20.667s-2.333-5.334-5.333-5.334Zm.666 7.834V24h-1.166v-.833a3.222 3.222 0 0 1-1.5-.834l1-.833c.166.333.666.667 1 .667.333 0 .666-.167.666-.5 0-.334-.5-.334-1-.5-.5-.167-1.333-.5-1.333-1.5 0-.667.5-1.334 1.167-1.5v-.834h1.166v.834c.5.166 1 .333 1.167.666l-1 .667a.917.917 0 0 0-.833-.5c-.334 0-.5.167-.5.5 0 .333.5.333 1 .5.666.167 1.5.5 1.5 1.5 0 .833-.5 1.5-1.334 1.667ZM34.5 16.833a2.167 2.167 0 1 0 0-4.333 2.167 2.167 0 0 0 0 4.333Zm0 11.834a2.167 2.167 0 1 0 0-4.334 2.167 2.167 0 0 0 0 4.334ZM29.667 22.5a1.833 1.833 0 1 0 0-3.667 1.833 1.833 0 0 0 0 3.667ZM12 22.5a1.833 1.833 0 1 0 0-3.667 1.833 1.833 0 0 0 0 3.667Z"
    />
    <path fill={props.fill} d="M3.333 11.667h5.5v12.5l-5.5 5.5v-18Z" />
  </svg>
);

export default SvgMoney;
